<template>
  <div id="app">
    <router-view/>
    
    <global-loader v-if="isLoading"/>
    <global-alert/>
    <global-tip/>
    <global-modal-container/>
  </div>
</template>

<script>
import GlobalLoader from '@/components/global/GlobalLoader'
import GlobalAlert from '@/components/global/GlobalAlert'
import GlobalTip from '@/components/global/GlobalTip'
import GlobalModalContainer from '@/components/global/GlobalModalContainer'

export default {
  name: "App",
  components: {
    GlobalLoader,
    GlobalAlert,
    GlobalTip,
    GlobalModalContainer
  },
  computed: {
    isLoading() {
      return this.$store.state.globalStore.loader.isLoading
    }
  }
}
</script>